import { Directive, HostListener, Input } from '@angular/core';

const ZERO_CHAR_CODE = 48;
const NINE_CHAR_CODE = 57;
const PERIOD_CHAR_CODE = 46;
const SUBMIT_CHAR_CODE = 13;

@Directive({
  selector: '[boiOnlyDigits]'
})
export class OnlyDigitsDirective {
  @Input('boiOnlyDigits') useOnlyDigits: boolean;
  @Input() disablePeriod: boolean;

  @HostListener('keypress', ['$event']) onKeyPressed(event): void {
    if (this.useOnlyDigits) {
      const isDigit = event.charCode >= ZERO_CHAR_CODE && event.charCode <= NINE_CHAR_CODE;
      const isPeriod = event.charCode === PERIOD_CHAR_CODE;
      const isSubmit = SUBMIT_CHAR_CODE === event.charCode;

      if (isSubmit) {
        return;
      }

      if (this.disablePeriod) {
        if (!isDigit) {
          event.preventDefault();
        }
      } else {
        if (!(isDigit || isPeriod)) {
          event.preventDefault();
        }
      }
    }
  }
}
